import { useRef, useImperativeHandle, useEffect } from "react";
export function useAutoResize(ref, autoResize, value) {
    const textAreaRef = useRef(null);
    useImperativeHandle(ref, () => textAreaRef.current);
    useEffect(() => {
        const textarea = textAreaRef.current;
        if (!textarea) {
            return;
        }
        const updateTextareaHeight = () => {
            if (autoResize) {
                textarea.style.height = "auto";
                textarea.style.height = textarea.scrollHeight + "px";
            }
        };
        if (autoResize) {
            updateTextareaHeight();
            textarea.addEventListener("input", updateTextareaHeight);
        }
        else {
            textarea.style.height = "";
        }
        return () => textarea.removeEventListener("input", updateTextareaHeight);
    }, [autoResize]);
    useEffect(() => {
        const textarea = textAreaRef.current;
        if (textarea && autoResize) {
            textarea.style.height = "auto";
            textarea.style.height = textarea.scrollHeight + "px";
        }
    }, [autoResize, value]);
    return { textAreaRef };
}
//# sourceMappingURL=use-auto-resize.js.map